import { findTenantConfigContent } from './globalFollowSettings';

export const KYC_CONFIG_KEY = 'kyc';

export const DEFAULT_KYC_CONFIG = {
  withdrawNeedKyc: true,
  bindWithdrawAddressNeedKyc: false,
  usedList: ['country', 'image'],
};

function toBoolean(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') {
      return true;
    }
    if (normalized === 'false' || normalized === '0') {
      return false;
    }
  }
  return Boolean(value);
}

/**
 * 從 tenant_config 表（經 GET /memberEnt/tenant-config）解析 KYC 設定。
 * 對應 item_key = 'kyc' 的 content 欄位（KycConfig）。
 */
export function normalizeKycConfig(content) {
  const source = content && typeof content === 'object' ? content : {};
  const usedList = Array.isArray(source.usedList) && source.usedList.length > 0
    ? source.usedList.filter((item) => typeof item === 'string' && item.trim())
    : [...DEFAULT_KYC_CONFIG.usedList];

  return {
    withdrawNeedKyc: toBoolean(source.withdrawNeedKyc, DEFAULT_KYC_CONFIG.withdrawNeedKyc),
    bindWithdrawAddressNeedKyc: toBoolean(
      source.bindWithdrawAddressNeedKyc,
      DEFAULT_KYC_CONFIG.bindWithdrawAddressNeedKyc
    ),
    usedList,
  };
}

/**
 * 從 tenant_config 列表（itemKey = 'kyc'）解析 KycConfig。
 */
export function pickKycConfigFromTenantList(list) {
  return normalizeKycConfig(findTenantConfigContent(list, KYC_CONFIG_KEY));
}

export function isKycVerified(realNameStatus) {
  return normalizeRealNameStatus(realNameStatus) === 'VERIFIED';
}

function normalizeRealNameStatus(status) {
  if (!status) {
    return '';
  }
  if (typeof status === 'string') {
    return status;
  }
  return status.name || status.code || '';
}

/**
 * 提款前是否仍需完成身份認證。
 */
export function needsKycForWithdraw(kycConfig, realNameStatus) {
  if (!kycConfig?.withdrawNeedKyc) {
    return false;
  }
  return !isKycVerified(realNameStatus);
}
